import { PlaceMedia } from './get'


export const URL = '/v2/pms/accomodations/:placeId/media/:imgId/mark_main/'

export type Req = void

export type Resp = PlaceMedia